
import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { updateVoucherRedeemDate } from '../../services/transaction.service';
import Dialog from '../ui/Dialog';
import { Grid, TextField } from '@material-ui/core';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';

import DatePicker from '../DatePicker/DatePicker.component';

const UpdateVoucherRedeemedDate = ({ data }) => {
    const [openModal, setOpenModal] = useState(false); 
    const [redeemedDate, setRedeemedDate] = useState(new Date());
    const [isLoading, setLoading] = useState(false);
    const { code_id, program_id } = data;

    const onSubmit = async () => {
        if (!redeemedDate) {
            alert('Please select the Voucher Redeemded date.');
            return;
        }
            setLoading(true);
             await updateVoucherRedeemDate({ 
                connect_program_id: program_id,
                voucher_code: code_id,
                payload: {
                    redeemdate: redeemedDate
                }
             })
             .then((res) => {
                 alert(res.message);
                 handleClose(true);
             })
            .catch((err) => alert(err.message))
             .finally(() => {
                 setLoading(false);
             })
        
    };
    
    const handleClose = (reload) => {
        setOpenModal(false); 
        if (reload) {
            window.location.reload();
        }
    }
    
    const formButtons = (
        <>
            <Button onClick={() => handleClose(false)} variant='contained'>
            Close
            </Button>
            <Button onClick={onSubmit} variant='contained' color='secondary'>
            Update
            </Button>
        </>
    );

    const formContent = (
        <>
          <Grid
            item
            container
            xs={12}
            spacing={2}
          >
            <Grid item xs={12}>
                 <DatePicker
                                    label='Redeemed Dates *'
                                    value={redeemedDate}
                                    // onChange={(date) => onDateChange(date, 'submission_date')}
                                     onChange={(date) => setRedeemedDate(date)} 
                                  />

            </Grid>
          </Grid>
        </>
    );
 const onClick = () => {         
        setOpenModal(true);
    };

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return (
        <>
            { <Dialog
                key='redeemed-date'
                open={openModal}
                title ='Update Redeemed Date'
                content = {formContent} 
                children = {formButtons} 
                onSubmit = {onSubmit}
                onClose = {() => handleClose(false)} 
            /> }
            
                <Button
                            variant="contained"
                            color="primary"
                            onClick={onClick}
                            style={{ marginRight: 8, marginBottom: 10 }}
                        >
                            Update Redeemed Date
                        </Button>
        </>
    )
}

export default UpdateVoucherRedeemedDate;